<template>
  <div>
    <v-data-table
      :value="[]"
      item-key="id"
      :headers="headers"
      :items="channels"
      @click:row="(item) => $emit('onSelect', item)"
      single-select
    >
      <template v-slot:[`item.channel`]="{ item }">
        <v-icon left>{{ typeIcons[item.channel] }}</v-icon>
        {{ $t(`channels.${item.channel}`) }}
      </template>
      <template v-slot:[`item.languages`]="{ item }">
        <v-chip color="primary lighten-3" text-color="white" small>
          <v-icon left small>mdi-web</v-icon>
          {{ $t(`languages.${getLanguage(item)}`) }}
        </v-chip>
      </template>
      <template v-if="isAdmin && false" v-slot:[`item.action`]="{ item }">
        <BtnSquare
          v-if="isAdmin"
          class="mr-1"
          :to="`/settings/channels/${item.channelId}`"
          icon="edit"
          colorBtn="admin"
          colorIcon="admin"
        />
        <DropMenu :items="dropMenuItems" isDisabled>
          <BtnSquare
            v-if="isAdmin"
            icon="mdi-dots-horizontal"
            colorBtn="admin"
            colorIcon="admin"
            disabled
          />
        </DropMenu>
      </template>
      <template v-slot:[`item.action`]="{ item }">
        <v-btn icon @click="openEditDialog(item)">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <!-- Edit Dialog -->
    <v-dialog v-model="editDialog" max-width="550">
      <v-card>
        <v-card-title>{{ $t('channelManagement.edit') }}</v-card-title>
        <v-card-text>
          <v-form ref="editForm" v-model="isFormValid">
            <v-text-field
              v-model="displayName"
              :label="$t('channelManagement.createDialog.nameLabel')"
              :rules="rules.displayName"
              autofocus
            />
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="closeEditDialog">{{ $t('common.cancel') }}</v-btn>
          <v-btn color="primary" :disabled="!isFormValid || !hasChanges()" @click="updateChannel">
            {{ $t('common.save') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import BtnSquare from '@/components/common/BtnSquare.vue';
import DropMenu from '@/components/common/DropMenu.vue';
export default {
  name: 'ChannelsList',
  components: {
    BtnSquare,
    DropMenu,
  },
  data() {
    return {
      isDeleteDialogOpen: false,
      teaserToDelete: null,
      typeIcons: {
        widget: 'mdi-comment-processing-outline',
        facebook: 'mdi-facebook',
        userlike: 'mdi-comment-processing-outline',
        whatsapp: 'mdi-whatsapp',
        freshchat: 'mdi-comment-processing-outline',
      },
      isFormValid: false,
      editDialog: false,
      editChannel: null,
      displayName: '',
      rules: {
        displayName: [
          (v) => (v || '').length >= 1 || this.$t('integrations.rules.minLength', {count: 1}),
          (v) => (v || '').length <= 128 || this.$t("integrations.rules.maxLength", {count: 128}),
          (v) => {
            const trimmed = v ? v.trim() : '';
            const isEqual = this.editChannel ? this.editChannel.displayName.trim() === trimmed : false;
            if (isEqual) return true; // No changes, otherwise check to be unique among Bot channels
            return this.uniqueNameRule(v) || this.$t('channelManagement.rules.uniqueName');
          }
        ],
      },
    };
  },
  created() {
    this.init();
  },
  computed: {
    ...mapGetters('auth', ['isAdmin']),
    ...mapGetters('bots', ['currentBotId']),
    ...mapGetters('channels', ['channels']),
    headers() {
      return [
        {
          text: 'Channel',
          align: 'start',
          value: 'displayName',
        },
        {
          text: 'Type',
          align: 'start',
          value: 'channel',
        },
        {
          text: this.$t('common.language'),
          align: 'start',
          value: 'languages',
        },
        {
          align: 'end',
          value: 'action',
        },
      ];
    },
    dropMenuItems() {
      // onClick, text, icon, isDisabled, target
      return [
        {
          text: 'Duplicate',
          icon: 'add',
          onClick: () => {
            console.log('Duplicate Channel ...');
          },
        },
      ];
    },
  },
  methods: {
    async init() {
      this.isLoading = true;
      await this.$store.dispatch('channels/loadChannels');
      this.isLoading = false;
    },
    getLanguage(item) {
      // no language set, return ['de']
      if (!item.languages || item.languages.length === 0) {
        return 'de';
      }
      
      return item.languages;
    },
    addSnackBarError(message) {
      this.$store.dispatch('channels/addSnackbarMessage', { message });
    },
    openEditDialog(item) {
      this.editChannel = item;
      this.displayName = item.displayName || '';
      this.editDialog = true;
      this.$nextTick(() => {
        if (this.$refs.editForm) this.$refs.editForm.resetValidation();
      });
    },
    closeEditDialog() {
      this.editDialog = false;
      this.editChannel = null;
      this.displayName = '';
    },
    hasChanges() {
      if (!this.editChannel) return false;
      const trimmedName = this.displayName.trim();
      return (
        trimmedName !== this.editChannel.displayName.trim()
      );
    },
    uniqueNameRule(val) {
      if (!val) return true;
      const channelNameSet = new Set(this.channels.map((c) => c.displayName.trim()));
      return !channelNameSet.has(val.trim()) || this.$t('channelManagement.rules.uniqueName')
    },
    async updateChannel() {
      if (!this.editChannel || !this.hasChanges()) return;

      const displayName = this.displayName.trim();
      const updatedChannel = {
        channelId: this.editChannel.channelId,
        displayName,
      };

      const { success } = await this.$store.dispatch('channels/updateChannel', {
        botId: this.currentBotId,
        channel: updatedChannel,
      });

      if (success) return this.closeEditDialog();
    },
  },
};
</script>
